import React, { useMemo } from "react"
import styled from "styled-components"
import astGetCustomField from "../../utils/astGetCustomField"
import TraefikLabsIcon from "../../images/inline-svgs/traefik-labs-icon.svg"

type CtaSmallWithIconProps = {
  cta: {
    node: {
      id: string
      title: string
      slug: string
      feature_image: string
      og_image: string
      childHtmlRehype: {
        htmlAst: any
      }
    }
  }
}

const CtaSmallWithIcon: React.FC<CtaSmallWithIconProps> = ({ cta }) => {
  const htmlAst = cta?.node?.childHtmlRehype?.htmlAst
  const ctaHtmlAst = useMemo(() => {
    return htmlAst?.children?.find(child => child.tagName === "cta-small")
  }, [htmlAst?.children])

  const ctaTitle = useMemo(() => astGetCustomField(ctaHtmlAst, "title"), [
    ctaHtmlAst,
  ])
  const ctaLink = useMemo(() => astGetCustomField(ctaHtmlAst, "link"), [
    ctaHtmlAst,
  ])

  return (
    <Container>
      {!!ctaLink && (
        <Inner>
          <Icon>
            {cta?.node?.og_image ? (
              <img src={cta?.node?.og_image} alt="" />
            ) : (
              <TraefikLabsIcon />
            )}
          </Icon>
          {!!ctaTitle && <Title>{ctaTitle}</Title>}
          <Link href={ctaLink} data-cta-title={ctaTitle || ""} />
        </Inner>
      )}
    </Container>
  )
}

const Container = styled.section`
  margin: 3em 0;
`

const Title = styled.span`
  font-size: 1.7rem;
  font-weight: 500;
  color: ${props => props.theme.colors.text.dark};
  text-decoration: underline;
  width: 100%;
`

const Icon = styled.span`
  width: 24px;
  height: 24px;
  margin-right: 12px;

  img {
    width: 100%;
    height: 100%;
  }
`

const Inner = styled.div`
  display: flex;
  align-items: center;
  border-bottom: none !important;
  text-decoration: none;
  position: relative;

  &:hover ${Title} {
    color: ${props => props.theme.colors.primary.base};
  }
`

const Link = styled.a`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-bottom: none !important;
`

export default CtaSmallWithIcon
